export default __webpack_public_path__ + "static/media/sliderFull_noThemeSelected.27d98475.svg";